<!--
  ~ Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<bs-dialog [header]="translationSchema.task.list.deleteMessage | translate"
          [visible]="visible()" (visibleChange)="visible.set($event)" [modal]="true">
  <div class="flex flex-column">
    <div class="flex flex-column mb-3">
      <span>{{ translationSchema.task.list.deleteQuestionTask | translate }}</span>
      <div class="mt-1">
        <button bsButton

                (click)="deleteTaskOnly()"><span bsButtonLabel>{{ translationSchema.task.list.deleteTaskOnly | translate }}</span></button>
      </div>
    </div>

    <div class="flex flex-column mb-3">
      <span>{{ translationSchema.task.list.deleteQuestionSegment | translate }}</span>
      <div class="mt-1">
        <button bsButton

                [disabled]="!segmentsDeletable()"
                (click)="deleteSegment()"><span bsButtonLabel>{{ translationSchema.task.list.deleteSegment | translate }}</span></button>
      </div>
    </div>

    <div class="flex flex-column">
      <span>{{ translationSchema.task.list.deleteQuestionSolution | translate }}</span>
      <div class="mt-1">
        <span [bsTooltip]="!solutionsDeletable() ? (translationSchema.task.list.solutionNotDeletable | translate) : (translationSchema.task.list.solutionDeletableWarning | translate)">
          <button bsButton

                  [disabled]="!solutionsDeletable()"
                  (click)="deleteTaskAndSolution()"><span bsButtonLabel>{{ translationSchema.task.list.deleteEntireSolution | translate }}</span></button>
        </span>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <button bsButton [text]="true"

            (click)="visible.set(false)"><span bsButtonLabel>{{ translationSchema.utils.close | translate }}</span></button>
  </ng-template>
</bs-dialog>
